<template>
  <div class="mantra-format" id="mantra-format">
    <router-view  @show-gallery-upload="$emit('show-gallery-upload')"
                  @show-take-picture="$emit('show-take-picture')"/>
  </div>
</template>

<script>
  export default {
    name: 'PickMantra',
    beforeMount: function () {
      this.$store.dispatch('updateShare', false);
      this.$store.dispatch('updateMantrapage', true);
    }
  }
</script>
